import { SwitchTable } from "./SwitchTable";
export default SwitchTable; 
